import type { MessageSchema } from './en'

const de: MessageSchema = {
  common: {
    cancel: 'Abbrechen',
    create: 'Erstellen',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    refresh: 'Aktualisieren',
    loading: 'Wird geladen…'
  },
  nav: {
    products: 'Produkte',
    upload: 'Hochladen',
    adhoc: 'Ad hoc',
    reports: 'Berichte',
    settings: 'Einstellungen'
  },
  sidebar: {
    expand: 'Ausklappen',
    collapse: 'Einklappen',
    expandSidebar: 'Seitenleiste ausklappen',
    collapseSidebar: 'Seitenleiste einklappen',
    logout: 'Abmelden'
  },
  topbar: {
    welcome: 'Willkommen, {name}',
    selectLanguage: 'Sprache auswählen'
  },
  footer: {
    copyright: 'Copyright © {year} Avalara Inc. Alle Rechte vorbehalten.'
  },
  auth: {
    redirecting: 'Weiterleitung zur Anmeldung…',
    completing: 'Authentifizierung wird abgeschlossen…',
    noCode: 'Kein Autorisierungscode empfangen',
    failed: 'Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    tryAgain: 'Erneut versuchen'
  },
  settings: {
    profiles: 'Profile',
    users: 'Benutzer'
  },
  reporting: {
    userTitle: 'Benutzerberichte',
    userSubtitle: 'Berichte zu Ihrer Aktivität anzeigen und herunterladen',
    userEmpty: 'Derzeit sind keine Berichte verfügbar.',
    profileTitle: 'Profilberichte',
    profileSubtitle: 'Berichte zur Aktivität Ihres Profils anzeigen und herunterladen',
    profileEmpty: 'Derzeit sind keine Profilberichte verfügbar.',
    loading: 'Berichte werden geladen…',
    emptyTitle: 'Keine Berichte verfügbar',
    download: 'Herunterladen',
    loadFailed: 'Berichte konnten nicht geladen werden'
  },
  eccn: {
    title: 'ECCN-Klassifizierung im Selbstservice',
    subtitle: 'Geben Sie Ihre Produktbeschreibung ein, um eine automatische ECCN-Klassifizierung zu erhalten',
    productLabel: 'Produktbeschreibung',
    productPlaceholder: 'Geben Sie eine ausführliche Produktbeschreibung, Spezifikationen und den Verwendungszweck ein…',
    descriptionRequired: 'Bitte geben Sie eine Produktbeschreibung ein',
    clear: 'Löschen',
    classify: 'Produkt klassifizieren',
    classifying: 'Klassifizierung läuft…',
    resultTitle: 'Klassifizierungsergebnis',
    confidence: '{value} % Konfidenz',
    code: 'ECCN',
    description: 'Beschreibung',
    controlReason: 'Kontrollgrund',
    exportRestrictions: 'Ausfuhrbeschränkungen',
    noRestrictions: 'Keine besonderen Beschränkungen',
    downloadReport: 'Bericht herunterladen',
    saveClassification: 'Klassifizierung speichern',
    readyTitle: 'Bereit zur Klassifizierung',
    readyHint: 'Geben Sie eine Produktbeschreibung ein und klicken Sie auf „{action}“, um zu beginnen'
  },
  dashboard: {
    totalProducts: 'Produkte insgesamt',
    totalProductsChange: '+12 % gegenüber dem Vormonat',
    classifications: 'Klassifizierungen',
    classificationsChange: 'Heute geprüfte Produkte',
    activeUsers: 'Aktive Benutzer',
    activeUsersChange: 'Derzeit online',
    complianceRate: 'Compliance-Quote',
    complianceRateChange: '+2,1 % Verbesserung',
    quickUpload: 'Schnell-Upload',
    quickUploadHint: 'Neue Produkte schnell hochladen und klassifizieren',
    dropFiles: 'Dateien hierher ziehen und ablegen',
    browseFiles: 'Dateien durchsuchen',
    recentActivity: 'Letzte Aktivitäten',
    recentActivityHint: 'Neueste Klassifizierungsaktivitäten',
    classifiedSuccessfully: 'Erfolgreich klassifiziert',
    pendingReview: 'Prüfung ausstehend',
    hoursAgo: 'vor {count} Std.',
    daysAgo: 'vor {count} T.',
    systemStatus: 'Systemstatus',
    systemStatusHint: 'Aktueller Status der Trade-Compliance-Dienste',
    serviceClassificationApi: 'Klassifizierungs-API',
    serviceFileUpload: 'Datei-Upload',
    serviceReporting: 'Berichte',
    operational: 'Betriebsbereit',
    issues: 'Störungen'
  },
  profiles: {
    addChild: 'Untergeordnetes Profil hinzufügen',
    idLabel: 'ID: {id}',
    information: 'Profilinformationen',
    nameLabel: 'Profilname',
    namePlaceholder: 'Profilnamen eingeben',
    parentIdLabel: 'Übergeordnete ID',
    noParent: 'Keine (Stamm)',
    save: 'Profil speichern',
    emptyTitle: 'Profil auswählen',
    emptyHint: 'Wählen Sie ein Profil aus der Struktur, um Details anzuzeigen und zu bearbeiten',
    createTitle: 'Untergeordnetes Profil erstellen',
    loadFailed: 'Profile konnten nicht geladen werden',
    detailsFailed: 'Profildetails konnten nicht geladen werden',
    saved: 'Profil erfolgreich gespeichert',
    saveFailed: 'Profil konnte nicht gespeichert werden',
    nameRequired: 'Bitte geben Sie einen Profilnamen an',
    created: 'Profil erfolgreich erstellt',
    duplicateName: 'Ein Profil mit diesem Namen existiert bereits',
    createFailed: 'Profil konnte nicht erstellt werden'
  },
  users: {
    count: '{count} Benutzer | {count} Benutzer',
    addNew: 'Neuen Benutzer hinzufügen',
    edit: 'Benutzer bearbeiten',
    username: 'Benutzername',
    email: 'E-Mail',
    firstName: 'Vorname',
    lastName: 'Nachname',
    role: 'Rolle',
    roleUser: 'Benutzer',
    roleAdmin: 'Administrator',
    status: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    lastLogin: 'Letzte Anmeldung',
    lastLogout: 'Letzte Abmeldung',
    assignedProfiles: 'Zugewiesene Profile',
    loadingProfiles: 'Profile werden geladen…',
    resetPassword: 'Passwort zurücksetzen',
    loadFailed: 'Benutzer konnten nicht geladen werden',
    requiredFields: 'Benutzername, Vorname und E-Mail sind erforderlich',
    profileRequired: 'Bitte wählen Sie mindestens ein Profil aus',
    usernameExists: 'Dieser Benutzername existiert bereits',
    saved: 'Benutzer erfolgreich gespeichert',
    saveFailed: 'Benutzer konnte nicht gespeichert werden',
    passwordReset: 'Passwort erfolgreich zurückgesetzt',
    passwordResetFailed: 'Passwort konnte nicht zurückgesetzt werden'
  },
  upload: {
    colUploaded: 'Hochgeladen',
    colClient: 'Kunde',
    colProfile: 'Profil',
    colDescription: 'Beschreibung',
    colFileName: 'Dateiname',
    colQuantity: 'Menge',
    colStatus: 'Status',
    colErrors: 'Fehler',
    stateNew: 'Neu',
    statePending: 'Ausstehend',
    stateRunning: 'Läuft',
    stateProcessing: 'Wird verarbeitet',
    stateCompleted: 'Abgeschlossen',
    stateError: 'Fehler',
    countProcessed: 'Verarbeitet: {processed} von {total}',
    countSuccess: 'Erfolgreich: {count}',
    countErrors: 'Fehler: {count}',
    countWarnings: 'Warnungen: {count}',
    configTitle: 'Upload-Konfiguration',
    configSubtitle: 'Konfigurieren Sie Ihre Upload-Einstellungen',
    clientLabel: 'Kunde',
    clientPlaceholder: 'Kundenname',
    profileLabel: 'Profil',
    profilePlaceholder: 'Profil auswählen…',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Geben Sie eine Beschreibung für diesen Upload ein…',
    destinationsLabel: 'Zielländer',
    destinationsPlaceholder: 'Zielländer auswählen…',
    duplicateStrategy: 'Umgang mit Duplikaten',
    overwriteDuplicates: 'Duplikate überschreiben',
    ignoreDuplicates: 'Duplikate ignorieren',
    actionsLabel: 'Aktionen',
    classification: 'Klassifizierung',
    fileTitle: 'Datei-Upload',
    fileSubtitle: 'Dateien zum Hochladen ziehen und ablegen oder auswählen',
    dropTitle: 'Dateien hierher ziehen und ablegen',
    formatHint: 'Muss im Excel-Format (.xlsx) vorliegen. Um eine Beispielvorlage herunterzuladen,',
    clickHere: 'hier klicken',
    headerRowHint: 'Die erste Zeile der Eingabedatei ist als Kopfzeile reserviert',
    selectFile: 'Datei zum Hochladen auswählen',
    selectAll: 'Alle auswählen',
    deselectAll: 'Auswahl aufheben',
    uploadedFiles: 'Hochgeladene Dateien',
    autoRefresh: 'Automatisch aktualisieren',
    confirmTitle: 'Upload bestätigen',
    confirmBody: 'Diese Datei wird nach {profile} hochgeladen. Sind Sie sicher?',
    uploadAction: 'Hochladen',
    listFailed: 'Dateiliste konnte nicht geladen werden',
    xlsxOnly: 'Es sind nur .xlsx-Dateien zulässig',
    tooLarge: 'Die Datei muss kleiner als 10 MB sein',
    processingStarted: 'Datei wird gespeichert und die Verarbeitung gestartet…',
    saved: 'Datei gespeichert, sie wird in Kürze verarbeitet',
    uploadFailed: 'Datei konnte nicht hochgeladen werden',
    templateFailed: 'Vorlage konnte nicht heruntergeladen werden'
  },
  reports: {
    userLabel: 'Benutzer',
    profileLabel: 'Profil',
    from: 'Von',
    to: 'Bis',
    exporting: 'Wird exportiert…',
    exportDetails: 'Details exportieren',
    productStatistics: 'Produktstatistik',
    addedProducts: 'Hinzugefügte Produkte:',
    attemptedClassifications: 'Versuchte Klassifizierungen:',
    classified: 'Klassifiziert:',
    unclassified: 'Nicht klassifiziert:',
    classifiedLabel: 'Klassifiziert',
    noData: 'Keine Daten verfügbar',
    noDataShort: 'Keine Daten',
    classificationsOverTime: 'Klassifizierungen im Zeitverlauf',
    totalAttempted: 'Versuchte Klassifizierungen insgesamt:',
    classificationsTooltip: '{count} Klassifizierungen',
    topItems: 'Top 5 Artikel',
    topItemsHint: 'Die 5 häufigsten Artikel über alle Produkte',
    topCategories: 'Top 5 Kategorien',
    topCategoriesHint: 'Die 5 häufigsten Kategorien nicht klassifizierter Produkte',
    topCodes: 'Top 5 Codes',
    topCodesHint: 'Die 5 häufigsten Codes klassifizierter Produkte',
    exported: 'Bericht erfolgreich exportiert',
    exportFailed: 'Bericht konnte nicht exportiert werden'
  },
  adhoc: {
    title: 'Produktklassifizierung',
    subtitle: 'Geben Sie unten die Produktdaten ein, um sofort eine HS-Code-Klassifizierung zu erhalten.',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Beschreiben Sie das Produkt hier…',
    descriptionHelp: 'Geben Sie eine ausführliche Produktbeschreibung an, einschließlich Materialien, Verwendungszweck und wesentlicher Eigenschaften.',
    originLabel: 'Ursprungsland',
    originPlaceholder: 'Ursprungsland auswählen…',
    destinationLabel: 'Zielland',
    destinationPlaceholder: 'Zielland auswählen…',
    classify: 'Klassifizieren',
    classifying: 'Klassifizierung läuft…',
    reset: 'Zurücksetzen',
    tipsTitle: 'Tipps zur Klassifizierung',
    tipsBestResults: 'Für beste Ergebnisse:',
    tipMaterial: 'Materialzusammensetzung angeben',
    tipUse: 'Verwendungszweck oder Funktion angeben',
    tipCharacteristics: 'Wesentliche physische Eigenschaften nennen',
    tipBrand: 'Marke oder Modell angeben, falls relevant',
    tipsExamples: 'Häufige Beispiele:',
    exampleShirt: 'Baumwoll-T-Shirt für Herren, Größe L',
    exampleKnife: 'Küchenmesser aus Edelstahl, 8 Zoll',
    exampleBattery: 'Lithium-Ionen-Akku für Smartphones',
    exampleTable: 'Esstisch aus Eichenholz, 6 Plätze',
    fieldDescription: 'Produktbeschreibung',
    fieldOrigin: 'Ursprungsland',
    fieldDestination: 'Zielland',
    missingFields: 'Bitte füllen Sie alle Pflichtfelder aus: {fields}',
    classificationTitle: 'Klassifizierung',
    classificationTitleFor: 'Klassifizierung: {description}',
    completed: 'Klassifizierung abgeschlossen',
    completedCreateRule: 'Klassifizierung abgeschlossen. Erstellen Sie jetzt Ihre Regel.',
    classifierNotStarted: 'Das Klassifizierungsfenster wurde nicht geladen. Klicken Sie, um es erneut zu versuchen.',
    missingHsCode: 'HS-Code für die Kalkulation fehlt',
    quoteTitle: 'Zoll- und Steuerkalkulation',
    quoteConfirmHeading: 'Möchten Sie Zölle und Steuern berechnen?',
    quoteConfirmBody: 'Damit können Sie die voraussichtlichen Zölle und Steuern für das klassifizierte Produkt berechnen.',
    classificationSummary: 'Zusammenfassung der Klassifizierung',
    hsCodeLabel: 'HS-Code:',
    originValueLabel: 'Ursprungsland:',
    destinationValueLabel: 'Zielland:',
    stackedHsCodes: 'Kombinierte HS-Codes:',
    noCancel: 'Nein, abbrechen',
    yesContinue: 'Ja, fortfahren',
    quoteParamsTitle: 'Kalkulationsparameter eingeben',
    classificationDetails: 'Details der Klassifizierung',
    optionalParameters: 'Optionale Parameter',
    shipmentType: 'Sendungsart',
    adValorem: 'Ad valorem',
    specific: 'Spezifisch',
    currency: 'Währung',
    countryOfOrigin: 'Ursprungsland',
    selectCoo: 'Ursprungsland auswählen…',
    quantity: 'Menge',
    unitValue: 'Stückwert ($)',
    total: 'Gesamt ($)',
    shipping: 'Versand ($)',
    handling: 'Bearbeitung ($)',
    insurance: 'Versicherung ($)',
    measureValue: 'Messwert',
    unit: 'Einheit',
    calculating: 'Wird berechnet…',
    getQuote: 'Kalkulation abrufen',
    quoteResultsTitle: 'Ergebnisse der Zoll- und Steuerkalkulation',
    quoteSummary: 'Zusammenfassung der Kalkulation',
    quoteIdLabel: 'Kalkulations-ID:',
    typeLabel: 'Typ:',
    shipmentLabel: 'Sendung:',
    currencyLabel: 'Währung:',
    lineHeading: 'Position {number} – {description}',
    hsBadge: 'HS: {code}',
    duties: 'Zölle',
    taxes: 'Steuern',
    colDescription: 'Beschreibung',
    colAmount: 'Betrag',
    colType: 'Typ',
    colTarget: 'Ziel',
    colRate: 'Satz',
    dutyDetails: 'Zolldetails und HS-Code-Anwendung',
    rateLabel: 'Satz:',
    methodLabel: 'Methode:',
    labelLabel: 'Bezeichnung:',
    totalDuty: 'Zölle gesamt',
    totalTax: 'Steuern gesamt',
    grandTotal: 'Gesamtsumme',
    disclaimerLabel: 'Haftungsausschluss:',
    disclaimerBody: 'Diese Schätzungen dienen nur zu Informationszwecken und entsprechen möglicherweise nicht den tatsächlich bei der Einfuhr erhobenen Zöllen und Steuern.',
    close: 'Schließen'
  },
  products: {
    tabDetails: 'Details',
    tabDestinations: 'Zielländer',
    tabHistory: 'Verlauf',
    tabAudit: 'Audit',
    tabCopy: 'Kopieren',
    colDate: 'Datum',
    colId: 'ID',
    colProfile: 'Profil',
    colDescription: 'Beschreibung',
    colCustomsDesc: 'Zollbeschr.',
    colItem: 'Artikel',
    colCategory: 'Kategorie',
    colDutyRates: 'Zollsätze',
    productId: 'Produkt-ID',
    description: 'Beschreibung',
    customsDescription: 'Zollbeschreibung',
    client: 'Kunde',
    source: 'Quelle',
    origin: 'Ursprungsland',
    selectOrigin: 'Ursprungsland auswählen…',
    manufacturerName: 'Herstellername',
    reclassify: 'Neu klassifizieren',
    classify: 'Klassifizieren',
    reset: 'Zurücksetzen',
    save: 'Speichern',
    selectProductDetails: 'Wählen Sie ein Produkt, um die Details anzuzeigen',
    tariffPackageRequired: 'Für diese Funktion benötigen Sie das Datenpaket mit Zolltarifinhalten.',
    destination: 'Zielland',
    selectDestination: 'Zielland auswählen…',
    hsCode: 'HS-Code',
    lookupTariffCode: 'Zolltarifnummer suchen',
    tariffCode: 'Zolltarifnummer',
    addTariffCode: 'Zolltarifnummer hinzufügen',
    viewCompliance: 'Compliance-Details anzeigen',
    removeDestination: 'Zielland entfernen',
    valid: 'Gültig',
    invalid: 'Ungültig',
    restrictions: 'Beschränkungen',
    selectProductDestinations: 'Wählen Sie ein Produkt, um die Zielländer anzuzeigen',
    noHistory: 'Kein Verlauf verfügbar',
    questions: 'Fragen',
    rationale: 'Begründung',
    hsVersion: 'HS-Version',
    noAudit: 'Keine Audit-Informationen verfügbar',
    copyFields: 'Felder kopieren',
    copyTo: 'Kopieren nach',
    checkedProducts: 'Die von mir markierten Produkte',
    allListedProducts: 'Alle derzeit aufgelisteten Produkte',
    productCount: '{count} Produkte',
    whenDataExists: 'Wenn bereits Daten vorhanden sind',
    overwrite: 'Vorhandene Daten überschreiben',
    doNotOverwrite: 'Vorhandene Daten nicht überschreiben',
    copying: 'Wird kopiert…',
    copy: 'Kopieren',
    selectProductCopy: 'Wählen Sie ein Produkt, um die Kopieroptionen zu konfigurieren',
    loadingProduct: 'Produktinformationen werden geladen…',
    matching: 'Treffer: {count}',
    checked: 'Markiert: {count}',
    exportAction: 'Exportieren',
    reclassifyAction: 'Neu klassifizieren',
    addProduct: 'Produkt hinzufügen',
    filters: 'Filter',
    newProduct: 'Neues Produkt',
    productIdRequired: 'Die Produkt-ID ist erforderlich.',
    descriptionRequired: 'Die Beschreibung ist erforderlich.',
    profile: 'Profil',
    selectProfile: 'Profil auswählen…',
    reclassifyTitle: 'Produkte neu klassifizieren',
    reclassifyConfirm: 'Möchten Sie {count} Produkte wirklich neu klassifizieren?',
    reclassifyNeedsSelection: 'Markieren Sie zuerst die Produkte, die neu klassifiziert werden sollen',
    reclassifyScopeQuestion: 'Welche Produkte möchten Sie neu klassifizieren?',
    reclassifyScopeChecked: 'Nur die von mir markierten Produkte',
    reclassifyScopeAll: 'Alle Produkte des Filters, auf allen Seiten',
    reclassifyWarning: 'Dies kann andere Benutzer beeinträchtigen, bis der Vorgang abgeschlossen ist.',
    reclassifyProgress: 'Produkte werden neu klassifiziert… {count}',
    processing: 'Wird verarbeitet…',
    complianceTitle: 'Compliance-Informationen',
    add: 'ADD',
    cvd: 'CVD',
    pga: 'PGA',
    yes: 'JA',
    no: 'NEIN',
    mfnRate: 'MFN-Satz',
    exportTitle: 'Produkte exportieren',
    exportConfirm: 'Möchten Sie die aktuelle Produktliste (gemäß den aktiven Filtern) nach Excel exportieren?',
    exportHint: 'Die Datei wird erstellt und Ihr Browser startet den Download automatisch.',
    preparingExcel: 'Excel-Datei wird vorbereitet. Ihr Browser startet den Download in Kürze.',
    dutyRatesTitle: 'Zollsätze',
    loadingDutyRates: 'Zollsätze werden geladen…',
    dutyRateDetails: 'Details zu den Zollsätzen',
    noDetailedDutyRates: 'Keine detaillierten Zollsätze verfügbar.',
    noDutyRates: 'Für dieses Produkt sind keine Zollsätze verfügbar.',
    classifiedHsVersion: 'Klassifiziert / HS-Version',
    all: 'Alle',
    classified: 'Klassifiziert',
    notClassified: 'Nicht klassifiziert',
    hsYear: 'HS-Jahr',
    item: 'Artikel',
    category: 'Kategorie',
    fromTo: 'Von / Bis',
    search: 'Suchen',
    dutyRatesFailed: 'Zollsätze konnten nicht geladen werden',
    detailsFailed: 'Produktdetails konnten nicht geladen werden',
    saved: 'Produkt erfolgreich gespeichert',
    saveFailed: 'Produkt konnte nicht gespeichert werden',
    profileNotReady: 'Das Benutzerprofil ist nicht bereit zum Kopieren',
    noCopyTargets: 'Keine Zielprodukte zum Kopieren ausgewählt',
    noCopySources: 'Keine Quellfelder zum Kopieren verfügbar',
    copied: 'Felder erfolgreich kopiert',
    copyFailed: 'Felder konnten nicht in die Produkte kopiert werden',
    copyStillRunning: 'Der Kopiervorgang ist nicht abgeschlossen und läuft möglicherweise noch auf dem Server. Prüfen Sie die Produkte, bevor Sie erneut kopieren.',
    copyLeaveConfirm: 'Ein Kopiervorgang läuft. Wenn Sie diese Seite verlassen, läuft er auf dem Server weiter, aber Sie sehen nicht, ob er erfolgreich war. Trotzdem verlassen?',
    createRequiredFields: 'Produkt-ID und Beschreibung sind erforderlich',
    created: 'Produkt erfolgreich erstellt',
    createFailed: 'Produkt konnte nicht erstellt werden',
    classifyRequirements: 'Für die Klassifizierung dieses Produkts ist eine Zollbeschreibung oder ein vorhandener HS-Code erforderlich',
    classifying: 'Produkt wird klassifiziert…',
    noHsCode: 'Der Klassifizierer hat keinen HS-Code zurückgegeben',
    noHsYear: 'Die Klassifizierung wurde ohne Angabe des HS-Jahres zurückgegeben',
    classifiedOk: 'Produkt erfolgreich klassifiziert',
    classifyCancelled: 'Klassifizierung abgebrochen oder fehlgeschlagen',
    classifierNotStarted: 'Das Klassifizierungsfenster wurde nicht geladen. Klicken Sie, um es erneut zu versuchen.',
    reclassifyStarted: 'Neuklassifizierung gestartet',
    reclassifyFailed: 'Neuklassifizierung konnte nicht gestartet werden',
    exportFailed: 'Export fehlgeschlagen',
    complianceFailed: 'Compliance-Daten konnten nicht geladen werden',
    tariffSaved: 'Zolltarifnummer gespeichert',
    tariffSaveFailed: 'Zolltarifnummer konnte nicht gespeichert werden',
    tariffSuggested: 'Zolltarifnummer vom Klassifizierer vorgeschlagen',
    noTariffCode: 'Der Klassifizierer hat keine Zolltarifnummer zurückgegeben',
    tariffLookupFailed: 'Suche nach der Zolltarifnummer fehlgeschlagen',
    deletingDestination: 'Zielland {destination} wird gelöscht…',
    destinationDeleted: 'Zielland gelöscht',
    destinationDeleteFailed: 'Zielland konnte nicht gelöscht werden'
  },
  rules: {
    title: 'Klassifizierungsregeln',
    subtitle: 'Sehen Sie gespeicherte Klassifizierungsregeln ein, die Antworten während der Produktklassifizierung automatisch ausfüllen.',
    count: 'Sie haben {count} Regeln',
    create: 'Regel erstellen',
    classifyFirst: 'Klassifizieren Sie zuerst ein Produkt, um eine Regel zu erstellen.',
    filterPlaceholder: 'Nach Name oder Artikel filtern…',
    filterAria: 'Regeln filtern',
    rowHint: 'Klicken Sie auf eine Zeile, um die Regeldetails anzuzeigen',
    colRuleName: 'Regelname',
    colItem: 'Artikel',
    colSip: 'SIP',
    detailsTitle: 'Regeldetails',
    ruleNameLabel: 'Regelname:',
    itemLabel: 'Artikel:',
    sipLabel: 'SIP:',
    constraints: 'Bedingungen',
    constraintsCaption: 'Bedingungen der ausgewählten Regel',
    colCategory: 'Kategorie',
    colType: 'Typ',
    colValues: 'Werte',
    typeSelection: 'Auswahl',
    typeValued: 'Wertbasiert',
    deleting: 'Wird gelöscht…',
    deleteRule: 'Regel löschen',
    close: 'Schließen',
    createTitle: 'Klassifizierungsregel erstellen',
    ruleNameField: 'Regelname',
    ruleNamePlaceholder: 'z. B. Baumwoll-T-Shirts',
    itemNameField: 'Artikelname',
    itemNamePlaceholder: 'z. B. T-Shirt',
    sipField: 'SIP',
    sipPlaceholder: 'z. B. 6109.10',
    hsCodeLabel: 'HS-Code:',
    originLabel: 'Ursprungsland:',
    destinationLabel: 'Zielland:',
    interactions: 'Interaktionen',
    selectAll: 'Alle auswählen',
    unselectAll: 'Auswahl aufheben',
    selectedCount: 'Ausgewählte Interaktionen: {count}',
    ruleApplied: 'Regel angewendet',
    ruleMismatch: 'Regelabweichung',
    category: 'Kategorie',
    type: 'Typ',
    values: 'Werte',
    select: 'Auswählen',
    deleteTitle: 'Regel löschen',
    deleteConfirm: 'Diese Aktion kann nicht rückgängig gemacht werden. {name} löschen?',
    delete: 'Löschen',
    classifyBeforeCreate: 'Bitte klassifizieren Sie ein Produkt, bevor Sie eine Regel erstellen.',
    noProfile: 'Kein Profil für Regeloperationen ausgewählt',
    requiredFields: 'Regelname, Artikel und SIP sind erforderlich',
    selectInteraction: 'Wählen Sie mindestens eine Interaktion aus',
    itemInteractionRequired: 'Diese Regel kann nicht gespeichert werden, ohne die Artikelinteraktion auszuwählen.',
    selectOneOption: 'Wählen Sie eine Option für „{label}“ aus',
    enterValues: 'Geben Sie Werte für „{label}“ ein',
    valuesMustTotal: 'Die Werte für „{label}“ müssen zusammen 100 % ergeben',
    created: 'Regel erfolgreich erstellt',
    createFailed: 'Regel konnte nicht erstellt werden',
    deleted: 'Regel erfolgreich gelöscht',
    deleteFailed: 'Regel konnte nicht gelöscht werden'
  },
  table: {
    noData: 'Keine Daten verfügbar',
    downloadErrorFile: 'Fehlerdatei herunterladen',
    showing: '{from} - {to} von {total} werden angezeigt',
    perPage: '{size} pro Seite',
    requiresAccess: 'Diese Funktion erfordert zusätzliche Berechtigungen'
  },
  header: {
    greeting: 'Hallo {name}'
  }
}

export default de
